import qs from 'qs';
import { touchWebClient, webApiClient } from 'tradera/utils/http';

export const createShipmentCheckout = async () =>
    webApiClient.post('/mytradera/shipmentcheckout/createshipmentcheckout');

export const deleteShipment = async (shipmentId) =>
    touchWebClient.post('/my/shipping/checkout/delete', { shipmentId });

export const getShippingOptions = (
    fromCountryCode,
    toCountryCode,
    purchaseOrderId
) => {
    const params = {
        fromCountryCode,
        toCountryCode,
        purchaseOrderId
    };

    return webApiClient.get(
        `/selling/shipmentcheckout/shipping-products-for-country-by-weight-span?${qs.stringify(
            params
        )}`
    );
};

export const setShipmentDetails = async (payload) =>
    webApiClient.post('/mytradera/shipmentcheckout/shipment', {
        shippingDetails: payload
    });

export const setShippingAsBooked = async (purchaseOrderId) =>
    webApiClient.post('/member/selling/item-shipping-booked', {
        purchaseOrderId: purchaseOrderId,
        booked: true
    });

export const setShippingAsShipped = async (purchaseOrderId) =>
    webApiClient.post('/member/selling/item-shipped', {
        purchaseOrderId: purchaseOrderId,
        shipped: true
    });

export const getMemberSoldItemShippingInfo = (purchaseOrderId) =>
    webApiClient.get(
        `/member/selling/sold-item/shipping-info-v2/${purchaseOrderId}`
    );

export const getPaymentOptions = async (shipmentCheckoutId) =>
    webApiClient.get(
        `/mytradera/shipmentcheckout/shipmentpaymentoptions/${shipmentCheckoutId}`
    );

export const initializePayment = async (formData) =>
    webApiClient.post(
        '/mytradera/shipmentcheckout/initializeshipmentpaymentattempt',
        formData
    );

export const getPaymentStatus = async (paymentAttemptId) =>
    webApiClient.get(
        `/mytradera/shipmentcheckout/shipmentpaymentattemptstatus/${paymentAttemptId}`
    );

export const completePayment = async (formData) =>
    webApiClient.post(
        '/mytradera/shipmentcheckout/completeshipmentpaymentattempt',
        formData
    );

export const cancelPayment = async (formData) =>
    webApiClient.post(
        '/mytradera/shipmentcheckout/cancelshipmentpaymentattempt',
        formData
    );

export const getExternalAuthData = async (paymentAttemptId) =>
    webApiClient.get(
        `/mytradera/shipmentcheckout/shipmentpaymentattemptauthenticationdata/${paymentAttemptId}`
    );

export const getBraintreeToken = async ({
    shipmentCheckoutId,
    paymentOption
}) =>
    webApiClient.get(
        `/mytradera/shipmentcheckout/shipmentbraintreeclienttoken/${shipmentCheckoutId}`,
        {
            params: {
                paymentMethod: paymentOption
            },
            withCredentials: true
        }
    );

// Export object for Sinon stubbing
const getShippingConfirmation = (shippingCheckoutId) =>
    touchWebClient.get(`/my/shipping/confirmation/${shippingCheckoutId}/data`);

const getShippingConfirmationStatus = (url) => touchWebClient.get(url);

export default {
    createShipmentCheckout,
    deleteShipment,
    getShippingOptions,
    setShipmentDetails,
    setShippingAsBooked,
    setShippingAsShipped,
    getMemberSoldItemShippingInfo,
    getPaymentOptions,
    initializePayment,
    getPaymentStatus,
    completePayment,
    cancelPayment,
    getExternalAuthData,
    getBraintreeToken,
    getShippingConfirmation,
    getShippingConfirmationStatus
};
